'use strict';

var Mirror = require('./utils').mirror;

module.exports = Mirror('@@auth', {
    LOGIN_ATTEMPT: true,
    LOGIN_SUCCESS: true,
    LOGIN_FAIL: true,
    LOGOUT_ATTEMPT: true,
    LOGOUT_SUCCESS: true,
    LOGOUT_FAIL: true
});


//////////////////
// WEBPACK FOOTER
// ./~/strange-auth/lib/types.js
// module id = 268
// module chunks = 0